module.exports = __webpack_public_path__ + "static/media/proposal_pickup_pin.51023097.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/flavours/cota/images/proposal_pickup_pin.svg
// module id = 613
// module chunks = 0